import { QUICK_ADD } from 'permissions/actions'

export const PERSON_TAG = '@@permissions/policy/personTag'

export default {
  [QUICK_ADD]: (user, options) => !!user.is_account_admin && !user.read_only
}
